import React from "react";
import PetrolPriceComponent from "../Shared/PetrolPrices";
import SlickSlider from "../SlickSlider/SlickSlider";
import FinancingBanks from "../CarFinancing/financingBanks/FinancingBanks";
import CustomDuty from "../Home/CustomDuty/CustomDuty";
import NewsDiscussion from "../Home/News&Discussion/News&Discussion";
import VideoHomePage from "../NewCars/New/VideoHomePage/VideoHomePage";
import ExploreProduct from "../Home/Products/Products";
import AuctionSheet from "../Home/AuctionSheet/AuctionSheet";
import StarRatings from "react-star-ratings";
import PetrolInPakistan from "./PricesInPakistan";
import PetrolFAQs from "../CarImport/PetrolFAQ";

const PetrolPrices = () => {
  const partners = [
    "/images/ac.png",
    "/images/hescol.png",
    "/images/PSO.png",
    "/images/shell.png",
    "/images/total.png",
  ];
  return (
    <div>
      <PetrolPriceComponent sectionClasses="bg-lightgrey" />

      <section
        id="popular-new-cars"
        className="section-padding  overflow-hidden"
      >
        <div className="container only-popular-cars">
          <PetrolInPakistan />
          <div className="d-flex justify-content-between">
            <h2 className="mb-0 align-self-center text-primary">
              Popular New <span className="text-capitalize">car</span>s
            </h2>
            <a className="adp-btn adp-btn-secondary" href="/new-cars/search/-/">
              View All
            </a>
          </div>

          {/* desktop section */}
          <div
            className="row popular-listing d-sm-flex d-none"
            style={{ marginTop: "30px" }}
          >
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/honda/hr-v-26">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.amazonaws.com/1666375486180Untitled%20design.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Honda HR-V 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 69.99 Lacs to 69.99 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/honda/civic-2">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16469021029011.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Honda Civic 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 75.99 Lacs to 86.49 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/suzuki/swift-75">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164699542813668.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Suzuki Swift 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 41.15 Lacs to 41.15 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/honda/city-1">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164698521898815.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Honda City 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 47.39 Lacs to 47.39 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/toyota/corolla-76">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16481063786051.png"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Toyota Corolla 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 52.69 Lacs to 66.09 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/suzuki/wagon-r-64">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164699601686374.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Suzuki Wagon R 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 27.89 Lacs to 30.39 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/suzuki/cultus-63">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/1646985984991Untitled%20design%20%283%29.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Suzuki Cultus 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 33.39 Lacs to 33.39 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-6 main-popular px-sm-3 px-2"
              style={{ marginBottom: "20px" }}
            >
              <div className="border rounded-2 overflow-hidden">
                <div className="popular-cars-img">
                  <a href="/new-cars/suzuki/alto-62">
                    <img
                      className="card-img-top"
                      src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16469042266031.jpg"
                      alt="featured car"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="popular-cars-details">
                  <h5>
                    <span className="card-title">Suzuki Alto 2023</span>
                  </h5>
                  <p className="popular-cars-price">
                    <span>PKR 21.56 Lacs to 24.23 Lacs</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* mobile section */}
          <SlickSlider
            sliderSettings={{
              dots: false,
              infinite: true,
              arrows: false,
              speed: 1000,
              slidesToShow: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              slidesToScroll: 1,
            }}
            sliderClassName="popular-listing-slider d-sm-none d-block mt-4"
          >
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/honda/hr-v-26">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.amazonaws.com/1666375486180Untitled%20design.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Honda HR-V 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 69.99 Lacs to 69.99 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/honda/civic-2">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16469021029011.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Honda Civic 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 75.99 Lacs to 86.49 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/suzuki/swift-75">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164699542813668.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Suzuki Swift 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 41.15 Lacs to 41.15 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/honda/city-1">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164698521898815.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Honda City 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 47.39 Lacs to 47.39 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/toyota/corolla-76">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16481063786051.png"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Toyota Corolla 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 52.69 Lacs to 66.09 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/suzuki/wagon-r-64">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/164699601686374.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Suzuki Wagon R 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 27.89 Lacs to 30.39 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/suzuki/cultus-63">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/1646985984991Untitled%20design%20%283%29.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Suzuki Cultus 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 33.39 Lacs to 33.39 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-listing-slider-slide">
              <div className="slide-inner mr-3">
                <div className="border rounded-2 overflow-hidden">
                  <div className="popular-cars-img">
                    <a href="/new-cars/suzuki/alto-62">
                      <img
                        className="card-img-top"
                        src="https://assets-autodeals.s3.eu-west-1.amazonaws.com/16469042266031.jpg"
                        alt="featured car"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                  <div className="popular-cars-details">
                    <h5>
                      <span className="card-title">Suzuki Alto 2023</span>
                    </h5>
                    <p className="popular-cars-price">
                      <span>PKR 21.56 Lacs to 24.23 Lacs</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SlickSlider>
        </div>
      </section>

      <section className="section-padding bg-lightgrey">
        <div className="container">
          <h2 className="text-center text-primary mb-5">
            Fuel Companies in Pakistan
          </h2>

          <div>
            {partners.map((image) => {
              return <img src={image} />;
            })}
          </div>

          <div className="mt-5 text-center">
            <p>
              Petrol Price in Pakistan has always been a topic of discussion in
              the Pakistani media. Petroleum products are obtained from crude
              oil. Starting from the production of crude oil to the refinement
              and distribution process, several different industries are
              involved in providing the finished product of petrol. All of the
              industries add their incurred costs to the price of petrol. Also,
              the government includes tax money in the price of fuel.
            </p>
            <p>
              In Pakistan, the International oil market rate also plays a huge
              role which is based on the value of the Rupee in the international
              market. Oil prices fluctuate. Due to the devaluation of the
              Pakistani Rupee, oil prices in the international market also
              increase for Pakistan.
            </p>
            <p>
              In the year 2021, The Government of Pakistan tried to regulate
              petrol prices in our country simply by decreasing the tax margin.
              Although! This strategy was not a long-term solution and issues
              like this are common in developing countries like Pakistan. This
              leads to inflation in the oil prices in Pakistan and makes
              consumers buy petrol.
            </p>
            <p>
              Ogra has a practice of revising fuel prices twice every month. The
              new prices for the oil are announced on the 15 and the last day of
              every month which usually remains in effect for 15 days.
            </p>
            <p>
              The Petroleum prices in Pakistan are directly related to the world
              of transformations of Oil and Gas. They are also affected by many
              other local factors such as the supply of petroleum resources in
              our country. As a result of this, the public witnesses frequent
              ups and downs in fuel prices.
            </p>
          </div>
        </div>
      </section>

      <CustomDuty />

      <PetrolFAQs />

      <NewsDiscussion />

      <VideoHomePage />

      <ExploreProduct bgClassName="bg-lightgrey2" />

      <AuctionSheet category={"car"} />
    </div>
  );
};

export default PetrolPrices;
